import { useEffect, useState } from "react";

const hasOpenDialog = () => {
  if (typeof document === "undefined") return false;

  const dialogs = Array.from(document.querySelectorAll(".MuiDialog-root"));
  return dialogs.some((dialog) => dialog.getAttribute("aria-hidden") !== "true");
};

export default function useAnyModalOpen() {
  const [isAnyModalOpen, setIsAnyModalOpen] = useState(false);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const sync = () => setIsAnyModalOpen(hasOpenDialog());
    sync();

    const observer = new MutationObserver(sync);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["aria-hidden", "class", "style"],
    });

    return () => observer.disconnect();
  }, []);

  return isAnyModalOpen;
}
